import fromFormat from "./fromFormat";

export default function fromYYYYMMDD(x: string) {
  return fromFormat(x, 'yyyy-MM-dd');
}
